import React from 'react'
import loadimage from '../assets/loading.gif';
import { Link } from 'react-router-dom';
export default function Links(props) {
    const ImageUrl = (props.imageUrl.trim().length === 0)? loadimage: props.imageUrl ;
  return (
    <Link to={props.htmlUrl} target='_blank'>
              <img src={ImageUrl} alt={`${props.name}`}  className={`${props.classname}`} />
            </Link>
  )
}
